const getRequest = () => {
	let url = location.href //获取url中"?"符后的字串
	let theRequest = new Object()
	let index = url.indexOf('?')
	if (index != -1) {
		let str = ''
		if (url.indexOf('#') != -1) {
			let index2 = url.indexOf('#')
			if (index < index2) {
				str = url.substring(index + 1, index2)
			} else {
				str = url.substring(index + 1)
			}
		} else {
			str = url.substring(index + 1)
		}
		let strs = str.split('&')
		for (let i = 0; i < strs.length; i++) {
			theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
		}
	}
	return theRequest
}

export default {
	getRequest
}